import type { MessageDescriptor } from 'react-intl';
import { campaignMessages as m } from './campaignMessages';

/** The 5 steps of the campaign setup (design outreach-v2 b1 nav). */
export const BUILDER_STEPS = ['song', 'who', 'message', 'sendFrom', 'start'] as const;
export type BuilderStep = (typeof BUILDER_STEPS)[number];

/** The `step=` values of the old 6-step builder, so an old link still opens a step. */
const OLD_STEPS: Record<string, BuilderStep> = {
  timing: 'start',
  mailbox: 'sendFrom',
  write: 'start',
};

export const STEP_LABELS: Record<BuilderStep, { title: MessageDescriptor; sub: MessageDescriptor }> = {
  song: { title: m.stepSong, sub: m.stepSongSub },
  who: { title: m.stepWho, sub: m.stepWhoSub },
  message: { title: m.stepMessage, sub: m.stepMessageSub },
  sendFrom: { title: m.stepSendFrom, sub: m.stepSendFromSub },
  start: { title: m.stepStart, sub: m.stepStartSub },
};

/** The label of the Next button that opens each step ("Next: who Plug contacts"). */
export const NEXT_LABELS: Record<BuilderStep, MessageDescriptor> = {
  song: m.next,
  who: m.nextWho,
  message: m.nextMessage,
  sendFrom: m.nextSendFrom,
  start: m.nextStart,
};

/** A `step=` query value (also an old one), else null. */
export function parseBuilderStep(value: string | null): BuilderStep | null {
  if (value === null) {
    return null;
  }
  return BUILDER_STEPS.find((step) => step === value) ?? OLD_STEPS[value] ?? null;
}

export function nextStep(step: BuilderStep): BuilderStep {
  return BUILDER_STEPS[Math.min(BUILDER_STEPS.length - 1, BUILDER_STEPS.indexOf(step) + 1)] ?? step;
}

export function previousStep(step: BuilderStep): BuilderStep {
  return BUILDER_STEPS[Math.max(0, BUILDER_STEPS.indexOf(step) - 1)] ?? step;
}

/** The angles a person can pick (music24-api `PITCH_ANGLES`); null lets Plug pick per person. */
export const BUILDER_ANGLES = [null, 'story', 'momentum', 'localScene'] as const;
export type BuilderAngle = (typeof BUILDER_ANGLES)[number];
